(function () {
    'use strict';

    angular
        .module('welcome')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('welcome', {
                url: '/welcome',
                sticky: true,
                views: {
                    'welcomeView': {
                        templateUrl: 'welcome/views/welcome.tpl.html',
                        controller: 'WelcomeCtrl',
                        controllerAs: 'welcome'
                    }
                },
                onEnter: function(UserPrivilegesService){
                   //UserPrivilegesService.setUserPrivilegeView("crew/menu");
                }
            });
    }
}());